import swal from "sweetalert";
declare var jQuery:any;
declare var lms_add_to_cart_sidebar:any;

// ----------- Helper functions
const toggleSpinnerOnButton = (button_element:any, on_off: any = undefined) => {
    if (jQuery(button_element).find('.temp_spinner').length == 0) {
        const spinner = `<span class="temp_spinner">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" stroke="#fff" viewBox="0 0 24 24"><script xmlns=""/><style>.spinner_QPB9{transform-origin:center;animation:spinner_4N1C 2s linear infinite}.spinner_QPB9 circle{stroke-linecap:round;animation:spinner_MX3P 1.5s ease-in-out infinite}@keyframes spinner_4N1C{100%{transform:rotate(360deg)}}@keyframes spinner_MX3P{0%{stroke-dasharray:0 150;stroke-dashoffset:0}47.5%{stroke-dasharray:42 150;stroke-dashoffset:-16}95%,100%{stroke-dasharray:42 150;stroke-dashoffset:-59}}</style><g class="spinner_QPB9"><circle cx="12" cy="12" r="9.5" fill="none" stroke-width="3"/></g><script xmlns=""/><script xmlns=""/></svg>
        </span>`;
        jQuery(button_element).append(spinner);
    }

    const temp_spinner = jQuery(button_element).find('.temp_spinner');
    if ( on_off ) {
        jQuery(temp_spinner).show()
        setTimeout(() => {
            jQuery(button_element).attr('disabled', 'disabled');
        }, 100);
    } else {
        jQuery(temp_spinner).hide()
        setTimeout(() => {
            jQuery(button_element).removeAttr('disabled');
        }, 100);
    }
}
// Keeps --vm-atc-vh in sync with the *visible* viewport height so the sidebar
// panel never extends behind the mobile browser chrome, which would hide the
// bottom-box (Add to Cart). visualViewport is Safari 13+; dvh would miss
// Safari 14. The SCSS only consumes the variable below 767px.
let atc_vh_frame: number = 0;

const syncAddToCartViewportHeight = () => {
    if (atc_vh_frame) {
        return;
    }

    atc_vh_frame = window.requestAnimationFrame(() => {
        atc_vh_frame = 0;

        const visual_viewport: any = (window as any).visualViewport;
        const height: number = (visual_viewport && visual_viewport.height)
            ? visual_viewport.height
            : window.innerHeight;

        document.documentElement.style.setProperty('--vm-atc-vh', (height / 100) + 'px');
    });
}
// ----------- End Helper functions

//Handles shop and product_page add to cart button
class AddToCartSideBars {
    lms_load_add_to_cart_btns: string = '.load-add-to-cart';
    wc_add_to_cart_btns: string = '[name="add-to-cart"]:not(.load-add-to-cart)';
    sidebar_open: boolean = false;

    constructor() {
        this.init();
        jQuery(document).on('woof-ajax-form-redrawing', () => {
            this.init();
        });
    }

    init() {
        //create one div inside with id addToCartSideNav child of body tag
        if(!jQuery('#addToCartSideNav .add-to-cart-container').length) {
            jQuery('body').append('<div id="addToCartSideNav" class="fl-page-content"><div class="woocommerce-page add-to-cart-container"></div></div>');
        }
        this.convertWCButtonIfNeeded();
        this.setupButtons();

        document.addEventListener('click', (event:any) => {
            var addToCartSideNav = document.querySelector('#addToCartSideNav');
            var clickedElement = event.target as Element;
            
            // Don't close the sidebar when clicking on step navigation elements
            if (clickedElement.closest('.close-step-2') || clickedElement.closest('#close-step-2')) {
                return;
            }
            
            if (addToCartSideNav && !addToCartSideNav.contains(event.target) && this.sidebar_open) {
                console.log('exit');
                //Close sidebar
                this.hideSidebar();
            }
        });
    }

    convertWCButtonIfNeeded() {
        if (lms_add_to_cart_sidebar.is_sidebar_add_to_cart_button) {
            const dataProductId = jQuery('.single_add_to_cart_button').val();
            if (dataProductId) {
                jQuery('.single_add_to_cart_button')
                    .attr('data-product-id', dataProductId)
                    .addClass('load-add-to-cart');
            } else {
                jQuery("[name=add-to-cart]").on('click', function () {
                    toggleSpinnerOnButton(this, true);
                });
            }
        }
    }

    setupButtons() {
        //Read the finished add to cart ajax event and propagate to our button
        jQuery('body').on('added_to_cart', (e:any, fragments:any, cart_hash:any, $button:any) => this.handleAjaxAddToCart(e, fragments, cart_hash, $button));

        jQuery(this.lms_load_add_to_cart_btns).on('click', (e: any) => this.handleAddToCartClick(e));
    }

    handleAddToCartClick(e: any) {
        e.preventDefault();
        const button = jQuery(e.currentTarget);
        const productId = button.data('product-id');

        toggleSpinnerOnButton(button, true);
        jQuery(this.lms_load_add_to_cart_btns).attr('disabled', 'disabled');

        //close sidebar if it is open
        if(jQuery('#addToCartSideNav').hasClass('open')){
            jQuery('#addToCartSideNav').hide().removeClass('open');
        }

        jQuery.ajax({
            type: 'POST',
            url: '/vmapp/admin/admin-ajax.php',
            data: { action: 'load_add_to_cart', product_id: productId, nonce: lms_add_to_cart_sidebar.nonce },
            success: (response: any) => this.loadCartSuccess(response, button),
            error: () => {
                this.toggleButtonState(button, false);
                this.showSidebarError();
            },
            complete: () => toggleSpinnerOnButton(button, false),
        });
    }

    handleAjaxAddToCart(e:any, fragments:any, cart_hash:any, $button:any){
        const product_id = jQuery($button).attr('data-product_id');
        const btn = jQuery(`button[type=submit][name=add-to-cart][value=${product_id}]`);
        this.toggleButtonState(btn, true);
    }

    loadCartSuccess(response: any, button: JQuery<HTMLElement>) {
        // wp_send_json_error() returns HTTP 200 with success:false, so it lands here too.
        if (!response || !response.success || !response.data || !response.data.html) {
            this.showSidebarError();
            return;
        }

        jQuery('.add-to-cart-container').html(response.data.html);
        jQuery(button).attr('disabled', 'disabled');
        jQuery('#addToCartSideNav').addClass('open');

        setTimeout(() => {
            this.setupSidebarEvents();
            const step1Exist = jQuery('.add-to-cart-container #step-1').length > 0;
            this.showStep(step1Exist ? 1 : 2); // Initialize view with Step 1
        }, 100);
    }

    showSidebarError(message: string = 'Something went wrong, please refresh the page') {
        const html = `
            <div class="step fl-page-content sidebar-error-view">
                <div class="header">
                    <div class="title-bar">
                        <h2 class="product_name"></h2>
                        <button type="button" class="close_button close-sidebar-button" aria-label="Close">
                            <span class="dashicons dashicons-no-alt"></span>
                        </button>
                    </div>
                </div>
                <div class="scrollable-content" style="display:flex;align-items:center;justify-content:center;text-align:center;padding:40px 28px;">
                    <div style="max-width:320px;margin:0 auto;">
                        <div style="width:72px;height:72px;margin:0 auto 22px;border-radius:50%;background:#fdecea;display:flex;align-items:center;justify-content:center;">
                            <span class="dashicons dashicons-warning" style="color:#e04b3f;font-size:38px;width:38px;height:38px;line-height:38px;"></span>
                        </div>
                        <h3 style="margin:0 0 10px;font-size:19px;font-weight:600;color:#2b2b2b;">Oops!</h3>
                        <p class="sidebar-error-message" style="margin:0 0 24px;font-size:15px;line-height:1.6;color:#666;">${message}</p>
                        <button type="button" class="button alt sidebar-error-refresh" style="cursor:pointer;" onclick="window.location.reload()">Refresh page</button>
                    </div>
                </div>
            </div>`;

        jQuery('.add-to-cart-container').html(html);
        jQuery('#addToCartSideNav').addClass('open').show();
        this.sidebar_open = true;

        jQuery('.add-to-cart-container .close-sidebar-button').off('click').on('click', () => this.hideSidebar());
    }

    setupSidebarEvents() {
        jQuery("#addToCartSideNav").on('ajax_reloaded', () => this.setupSteps());
        this.setupSteps();
        this.autoSelectPrices();
    }

    autoSelectPrices() {
        //If no price is selected, select the first one available
        // the elements .ticket-list input[type=radio][name=member_price]
        // Each ticket-list has its own set of member prices
        jQuery('.step:not(.hidden)').each(function () {
            const ticketList = jQuery(this);
            const firstPrice = jQuery(ticketList).find('input[type=radio][name=member_price]:not(:disabled):first');
            if (firstPrice.length) {
                firstPrice.prop('checked', true);
                setTimeout(()=>{
                    firstPrice.trigger('change');
                }, 300);
            }
        });

        setTimeout(() => {
            jQuery('[name=member_price]').trigger('change');
        }, 100);
    }

    setupSteps() {
        jQuery('.ticket-item:not(.disabled)').off('click').on('click', (e: any) => {
            e.preventDefault();
            const variationId = jQuery(e.currentTarget).attr('variation_id');
            this.showStep(2, variationId);
            this.autoSelectPrices();
        });

        jQuery('.ticket-option').off('click').on('click', (e: any) => {
            e.preventDefault();
            jQuery(e.currentTarget).find('[force-check]').prop('checked', true);
            jQuery(e.currentTarget).find('[force-check]').prop('checked', true).trigger('change');
            
            if(jQuery(e.currentTarget).find('[force-check]').length == 0){
                jQuery(e.currentTarget).find('input[type=radio]').prop('checked', true).trigger('change');
            }
        });

        jQuery('.add-to-cart-container .payment .loop_content').each(function () {
            const loop_content = jQuery(this);
            jQuery(loop_content).siblings('.single_content').find('form').children().each(function () {
                if ( jQuery(this).attr('type') !== 'submit') {
                    jQuery(loop_content).prepend(jQuery(this));
                }
            })
            jQuery(loop_content).siblings('.single_content').children(':not(form)').each(function () {
                jQuery(loop_content).prepend(jQuery(this));
            });
        });

        //Add any field as data to be send, WC sends all data-* attributes that are in the add to cart ajax button
        jQuery('.add-to-cart-container .loop_content [name]').on('change', function (e: any) {
            const value = jQuery(e.currentTarget).val();
            const input_name = jQuery(e.currentTarget).attr('name');
            jQuery(e.currentTarget).parents('.bottom-box').find('a.ajax_add_to_cart').attr(`data-${input_name}`, value);
        });

        jQuery('.add-to-cart-container .loop_content a.button').addClass('alt');
    }

    showStep(step: number, variationId?: string) {
        const step1Exist = jQuery('.add-to-cart-container #step-1').length > 0;
        // Only handle close_button that are not close-step-2 buttons
        jQuery('.add-to-cart-container .close_button:not(.close-step-2)').off('click').on('click', () => {
            if(step === 1){
                this.hideSidebar();
            } else if(step === 2){
                if(step1Exist){
                    this.showStep(1); // When closing, show Step 1 if it exists
                } else {
                    this.hideSidebar();
                }
            }
        });

        if (step === 1) {
            jQuery('.add-to-cart-container .step-2').addClass('hidden');
            jQuery('.add-to-cart-container #step-1').removeClass('hidden');
            jQuery('#addToCartSideNav').show();
        } else if (step === 2) {
            jQuery('.add-to-cart-container #step-1').addClass('hidden');
            if (variationId) {
                jQuery('.add-to-cart-container .step-2').addClass('hidden');
                jQuery(`.add-to-cart-container [step-2-for="${variationId}"]`).removeClass('hidden');
            } else {
                jQuery('.add-to-cart-container .step-2').removeClass('hidden');
            }
            jQuery('#addToCartSideNav').show();

            jQuery('.add-to-cart-container .step-2 [name=member_price]').attr('data-variation_id', variationId);
           

            this.forceCheck();
        }


        jQuery('.add-to-cart-container [name=member_price]').off('change').on('change', (e: any) => {
            const is_checked = jQuery(e.currentTarget).prop('checked');
            if (is_checked) {
                const memberPrice = jQuery(e.currentTarget).val();
                jQuery(e.currentTarget).parents('.add-to-cart-container').find('a.ajax_add_to_cart').attr('data-member_price', memberPrice);
                jQuery('.add-to-cart-container [name=member_price][type=hidden]').val(memberPrice);
            }
        });

        this.afterShowStep(step)
    }

    afterShowStep(step: number){
        this.sidebar_open = true;
        setTimeout(() => {
            jQuery(this.wc_add_to_cart_btns).off('click').on('click', () => {
                //disable the button
                toggleSpinnerOnButton(this.wc_add_to_cart_btns, true);
            });
        }, 100);
    }

    forceCheck() {
        jQuery('.step-2:not(.hidden) [force-check]:visible').prop('checked', true).trigger('change');
    }

    hideSidebar() {
        jQuery('#addToCartSideNav').hide();
        this.sidebar_open = false;
    }

    toggleButtonState(button: JQuery<HTMLElement>, enabled: boolean) {
        toggleSpinnerOnButton(button, !enabled);
        if (enabled) {
            button.removeAttr('disabled');
        } else {
            button.attr('disabled', 'disabled');
        }
    }
}



jQuery(document).ready(function(){
    new AddToCartSideBars();

    syncAddToCartViewportHeight();

    window.addEventListener('resize', syncAddToCartViewportHeight);
    window.addEventListener('orientationchange', syncAddToCartViewportHeight);

    const visual_viewport: any = (window as any).visualViewport;
    if (visual_viewport) {
        // 'scroll' fires as the mobile browser chrome collapses/expands.
        visual_viewport.addEventListener('resize', syncAddToCartViewportHeight);
        visual_viewport.addEventListener('scroll', syncAddToCartViewportHeight);
    }
})


jQuery(document).ready(function($) {
                
    // Handle radio button change
    $(document).on('change', 'input[name="member_price"]', function() {
        updatePrices( $( this ) );
    });

    
    function updatePrices( element ) {
        const $container = element.closest('.step-2, .default-sidebar-view');
        

        const $totalSection = $container.find('.total-section');

        // Find all price options
        const $options = $container.find('.ticket-option');
        if ($options.length === 0) return;
        
        // Find general price option
        let generalPrice = 0;
        $options.each(function() {
            if ($(this).data('role') === 'General Price') {
                generalPrice = parseFloat($(this).data('price')) || 0;
            }
        });


        // Find selected price option
        const $selectedOption = element.closest('.ticket-option');

        if ($selectedOption.length === 0) return;
        
        const selectedPrice = parseFloat($selectedOption.data('price')) || 0;

        
        // Update subtotal - always show general price
        $totalSection.find('.subtotal-amount').html(lms_add_to_cart_sidebar.currency_symbol + selectedPrice.toFixed(2));
        
        // Calculate discount amount (general price - selected price)

        const discountAmount = Math.max(0, generalPrice - selectedPrice);
        

        // Calculate discount percentage
        let discountPercent = 0;
        if (discountAmount > 0 && generalPrice > 0) {
            discountPercent = Math.round((discountAmount / generalPrice) * 100);
        }
        
        // Update discount row

        const $discountRow = $totalSection.find('.discount');
        $discountRow.hide();


        if(discountPercent > 0){
            // Update discount text and amount
            $totalSection.find('.subtotal-amount').html(lms_add_to_cart_sidebar.currency_symbol  + generalPrice.toFixed(2));
            $discountRow.find('span').first().html( $selectedOption.data('role') + '  (' + discountPercent + '%)');
            $discountRow.find('bdi').last().html('<span class="woocommerce-Price-currencySymbol">' + lms_add_to_cart_sidebar.currency_symbol + '</span>' + discountAmount.toFixed(2));
            $discountRow.show();
        }
        
        
        // Update final total - always show selected price
        //$totalSection.find('.final-total span').last().html('$');
        $totalSection.find('.final-total bdi').last().html('<span class="woocommerce-Price-currencySymbol">' + lms_add_to_cart_sidebar.currency_symbol + '</span>' + selectedPrice.toFixed(2));
        
    }
    

});
// --------------------------------------------


jQuery(document).ready(function($) {
                
    // Function to select the first radio button if none is selected
    function selectFirstRadioIfNoneSelected($container) {
        const $radioButtons = $container.find('input[name="member_price"]');
        
        if ($radioButtons.length > 0 && $radioButtons.filter(':checked').length === 0) {
            // Select the first radio button that's not disabled
            const $firstRadio = $radioButtons.not(':disabled').first();
            if ($firstRadio.length) {
                $firstRadio.prop('checked', true);
                
                // Update visuals
                $firstRadio.closest('.ticket-option').addClass('selected').attr('aria-checked', 'true');
                
                // Trigger change event to update pricing
                $firstRadio.trigger('change');
            }
        }
    }
    
    $(document).on('click', '.events-listing .event-item:not(.disabled)', function() {
        const variationId = $(this).data('variation-id');
        
        // Hide step 1
        $('#step-1').addClass('hidden');
        
        // Show step 2 for the selected variation
        const $step2 = $('.step-2[step-2-for="' + variationId + '"]');
        $step2.removeClass('hidden');
        
        // Check if there's no radio selected in step-2 and select the first one
        setTimeout(function() {
            selectFirstRadioIfNoneSelected($step2);
        }, 100);
    });
    
    // Handle back button click (Step 2 -> Step 1)
    // Support both ID and class selectors for better compatibility
    $(document).on('click', '#close-step-2, .close-step-2', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling to parent elements
        
        // Hide all step 2 divs
        $('.step-2').addClass('hidden');
        
        // Show step 1
        $('#step-1').removeClass('hidden');
    });
    
    // Handle close button click (close the sidebar)
    $(document).on('click', '.close-sidebar-button, #close-step-1', function(e) {
        e.preventDefault();
        // Handle sidebar closing - usually managed by parent code
        $(this).closest('.lms-add-to-cart-sidebar-overlay').removeClass('open');
    });
    
    // Also handle direct radio button clicks - explicitly prevent propagation
    $(document).on('click', '.ticket-option-radio', function(e) {
        e.stopPropagation();
        $(this).closest('.ticket-option').trigger('click');
    });
    
    // Keyboard support for ticket options
    $(document).on('keydown', '.ticket-option:not(.disabled)', function(e) {
        if (e.keyCode === 13 || e.keyCode === 32) { // Enter or Space
            e.preventDefault();
            $(this).trigger('click');
        }
    });
    
    // Initialize on load
    
    // Ensure first ticket option is selected if none is
    $('.ticket-list').each(function() {
        const $list = $(this);
        if ($list.find('.ticket-option.selected').length === 0) {
            $list.find('.ticket-option:not(.disabled)').first().trigger('click');
        }
    });
    
    // Check for visible step-2 sections on page load
    setTimeout(function() {
        $('.step-2:visible, .default-sidebar-view:visible').each(function() {
            selectFirstRadioIfNoneSelected($(this));
        });
    }, 300);
});